import React from "react";
import { connect } from "react-redux";
import ProfileInfoComponent from "components/profile/ProfileInfoComponent";

const UserProfile = () => {
  const activeColor = {
    color: "#035184"
  };

  return (
    <div className="Profile-component">
      <ProfileInfoComponent activeColor={activeColor} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(UserProfile);
